// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__19eU4","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__JFFWf"};